'use client';

import { useLocale, useTranslations } from 'next-intl';

import { LOCALE_LABELS, switchLocale } from '../i18n/locale-switch';
import { routing } from '../i18n/routing';

/**
 * Public language picker shown in the homepage header for signed-out visitors
 * (signed-in users get one in the account menu). Selecting a language hard-
 * navigates to that locale — a full reload, see `switchLocale` — so the page,
 * `<html lang>` and Clerk UI all reflect the choice and the value can't go stale.
 */
export function LanguageSwitcher(): React.JSX.Element {
  const locale = useLocale();
  const t = useTranslations('home');

  const onChange = (
    // oxlint-disable-next-line typescript/prefer-readonly-parameter-types -- React event handler signature is fixed
    event: React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    switchLocale(event.target.value);
  };

  return (
    <select
      aria-label={t('languageLabel')}
      value={locale}
      onChange={onChange}
      className="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm text-gray-900"
    >
      {routing.locales.map((code) => (
        <option key={code} value={code}>
          {LOCALE_LABELS.get(code) ?? code}
        </option>
      ))}
    </select>
  );
}
